import { ReactElement } from "react";
import ConnectionPage from "./ConnectionPage";
import { useAppSelector } from "../../redux/store";
import './connection.css';

interface ConnectionProps {
  children: ReactElement
}

export default function Connection({ children }: ConnectionProps) {
  const token = useAppSelector(state => state.appState.token);

  return !token ?
    <div className="fullscreenv1"><ConnectionPage /></div>
    : children;
}